'use client';
import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/contexts/AuthContext';
import LandingPage from './landing/components/LandingPage';
import OnboardingFlow from '@/components/OnboardingFlow';

const ONBOARDING_KEY = 'smartcontrax_onboarding_done';

export default function Page() {
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    if (loading || !user) return;

    const done = localStorage.getItem(`${ONBOARDING_KEY}_${user?.id}`);
    if (!done) {
      const createdAt = user?.created_at ? new Date(user.created_at)?.getTime() : 0;
      const isRecent = Date.now() - createdAt < 5 * 60 * 1000;
      if (!isRecent) {
        router?.push('/project-workspace');
      }
      // else: stay to show OnboardingFlow below
    } else {
      router?.push('/project-workspace');
    }
  }, [user, loading, router]);

  // Authenticated user — show onboarding for brand-new accounts
  if (!loading && user) {
    const done = typeof window !== 'undefined'
      ? localStorage.getItem(`${ONBOARDING_KEY}_${user?.id}`)
      : '1';
    if (!done) {
      const createdAt = user?.created_at ? new Date(user.created_at)?.getTime() : 0;
      const isRecent = Date.now() - createdAt < 5 * 60 * 1000;
      if (isRecent) {
        return (
          <OnboardingFlow
            onComplete={() => {
              localStorage.setItem(`${ONBOARDING_KEY}_${user?.id}`, '1');
              router?.push('/project-workspace');
            }}
            onSkip={() => {
              localStorage.setItem(`${ONBOARDING_KEY}_${user?.id}`, '1');
              router?.push('/project-workspace');
            }}
          />
        );
      }
    }
    // Returning authenticated user — redirect in progress, show spinner
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Unauthenticated (or still loading) → show landing page immediately
  return <LandingPage />;
}